/**
 * Global.js
 *
 * Global theme interactions. Codekit app is used for compiling
 */
const $ = window.jQuery;

class Coastal1_Routing {
  constructor() {
    this.copyOnClick();
  }

  copyOnClick() {
    $("[data-copy]").on("click", (event) => {
      const $this = $(event.currentTarget);
      const value = $this.data("copy");

      navigator.clipboard.writeText(value).then(
        () => {
          console.log(`Successfully copied "${value}" to clipboard.`);
          $(".routing-number__copy").hide();
          $(".routing-number__copied").show();
        },
        (err) => {
          console.log(`Failed to copy "${value}" to clipboard.`, err);
        }
      );
    });
  }
}

new Coastal1_Routing();
